<template>
  <section>
    <subir-documento-adjunto />
    <VerDocumento />
    <h3 class="primary--text"><v-icon color="primary">backup</v-icon> Documentos adjuntos</h3>
    <v-card>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="table"
          class="elevation-1"
          :loading="loading"
        >
          <template v-slot:items="props">
            <td class="text-xs-center">{{ props.index + 1 }}</td>
            <td class="text-xs-center">{{ props.item.nombre_documento }}</td>
            <td class="text-xs-center">
              {{
                props.item.doc_requisitos.length > 0
                  ? $moment(props.item.doc_requisitos[0].fecha_emision).format(
                      "DD/MM/YYYY"
                    )
                  : ""
              }}
            </td>
            <td class="text-xs-center">
              {{
                props.item.doc_requisitos.length > 0
                  ? props.item.doc_requisitos[0].nro_certificado
                  : ""
              }}
            </td>
            <td class="text-xs-center">
              {{
                props.item.doc_requisitos.length > 0
                  ? props.item.doc_requisitos[0].observacion
                  : ""
              }}
            </td>
            <td class="text-xs-center">
              {{
                props.item.parametro_tipo.valor
              }}
            </td>
            <td class="text-xs-center">
              <v-btn
                icon
                color="primary"
                @click.native="adjuntarArchivo(props.item)"
                v-if="props.item.doc_requisitos.length == 0"
              >
                <v-icon>attach_file</v-icon>
              </v-btn>
              <v-btn 
                icon
                color="error"
                v-if="(props.item.doc_requisitos.length > 0 && estado==1)"
                slot="activator"
                @click="borrar(props.item.doc_requisitos[0].id)"
              >
                <v-icon>delete</v-icon>
              </v-btn>
              <v-btn
                icon
                color="info"
                v-if="props.item.doc_requisitos.length > 0"
                @click.native="verDocumento(props.item.doc_requisitos[0])"
              >
                <v-icon>visibility</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import CrudTable from "@/common/util/crud-table/CrudTable.vue"; // Componente Tabla Dinámica
import crud from "@/common/util/crud-table/mixins/crud-table"; // Funciones y Metodos
import SubirDocumentoAdjunto from "../dialogs/SubirDocumentoAdjunto.vue";

import VerDocumento from "../dialogs/VerDocumento.vue";
export default {
  mixins: [crud],
  props: ["persona"],
  components: { SubirDocumentoAdjunto, VerDocumento },
  data() {
    return {
      headers: [
        {
          text: "Nro.",
          align: "center",
          sortable: false,
          value: "",
        },
        {
          text: "Nombre del documento",
          value: "nombre_documento",
          sortable: false,
          align: "center",
        },
        {
          text: "Fecha de emisión/ Fecha de validez",
          value: "nombre_documento",
          sortable: false,
          align: "center",
        },
        {
          text: "Nro. certificado",
          value: "nro_certificado",
          sortable: false,
          align: "center",
        },
        {
          text: "Observación",
          value: "nombre_documento",
          sortable: false,
          align: "center",
        },
        {
          text: "Tipo",
          value: "nombre_documento",
          sortable: false,
          align: "center",
        },
        {
          text: "Acciones",
          value: "",
          sortable: false,
          align: "center",
        },
      ],
      documento_requisitos: [],
      loading: false,
      persona_doc_requisitos: [],
      table: [],
      estado:[],
      rol:[]
    };
  },
  mounted() {
    this.cargarDatos();
    this.$bus.$on("verDocumento", (item) => {
      this.url = item;
      this.dialog = true;
    });
    this.$bus.$on("closeDialogDocumentosAdjuntos", () => {
      this.cargarDatos();
    });
    this.obtenerEstadoFicha();
  },
  methods: {
    async borrar(id) {
      this.loading = true;
      try {
        let res = await this.$service.graphql({
          query: `
            mutation{
              personaDocRequisitoDelete(id: ${id}){
                deleted
              }
            }
          `,
        });
        this.cargarDatos();
      } catch (error) {
        console.log(error);
      }
    },
    async verDocumento(item) {
      this.$bus.$emit("openDialogVerDocumento", item);
    },
    async cargarDatos() {
      this.loading = true;
      try {
        let res = await this.$service.graphql({
          query: `
              query{
                documentoRequisitos{
                  rows{
                    id
                    nombre_documento
                    parametro_tipo{
                                        id 
                                        valor
                                                }
                  }
                }
              }
            `,
        });
        this.documento_requisitos = res.documentoRequisitos.rows;
        res = await this.$service.graphql({
          query: `
              query{
                personaDocRequisitos(id_persona: ${this.persona.id}){
                  rows{
                    id
                    id_persona
                    id_doc_requisito
                    fecha_emision
                    nro_certificado
                    id_doc_requisito
                    
                    observacion
                    id_estado
                    url_documento
                    
                  }
                }
              }
            `,
        });
        this.persona_doc_requisitos = res.personaDocRequisitos.rows;
        let aux = [];
        let table = [];
        this.documento_requisitos.forEach((item) => {
          this.persona_doc_requisitos.forEach((elem) => {
            if (
              parseInt(item.id) === elem.id_doc_requisito &&
              elem.id_estado === 1
            ) {
              aux.push(elem);
            }
          });
          item.doc_requisitos = aux;
          aux = [];
          table.push(item);
        });
        this.table = table;
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    async obtenerEstadoFicha() {
      let user = this.$storage.get("user");
       this.rol=user.roles[0].id;
      let respuesta = await this.$service.graphql({
        query: `
          query{
                  vListafichas(id_persona:${user.id_persona}){
                    rows{
                      id_persona
                      nombre
                      nro_doc
                      id_estado_ficha
                      estado_ficha
                      habilitado
                      item
                      id_unidad
                      unidad      
                    }
                  }
                }
        `
      });
      this.estados_ficha = respuesta.vListafichas.rows;
      this.estado=this.estados_ficha[0].habilitado
      let roles = user.roles;
      roles.forEach(element => {
      if(element.id==115){
        this.estado=1
      }
    });
    },
    adjuntarArchivo(item) {
      this.$bus.$emit("openDialogSubirDocumento", item);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/ficha_personal/components/DocumentosAdjuntos.vue